import { mapState } from 'vuex';

const providerPlanMixin = {
  computed: {
    ...mapState({
      plans: state => state.providerPlan.plans,
      services: state => state.providerPlan.services,
    }),
  },
};

export default providerPlanMixin;
